(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/utils/api-bet.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/utils/api-bet.js'); 
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class Bet {
  constructor(_ref) {
    var _svs$numbergames$game;
    let {
      wagerModel,
      day
    } = _ref;
    this.wagerModel = wagerModel;
    this.validBoards = wagerModel.get('boards').getValidBoards();
    this.day = day;
    this.productItsId = svs.numbergames.productMapping.getProductItsId(day || wagerModel.get('productId'));
    const isAlwaysOpen = !this.isSelfService() && ((_svs$numbergames$game = svs.numbergames.game_model.rulesRadio.request('rules')) === null || _svs$numbergames$game === void 0 ? void 0 : _svs$numbergames$game.alwaysOpen);
    const bet = new svs.tur.payment.api.jupiter.request.Bet({
      productId: this.productItsId,
      betAmountSalesGroup1: this.betAmountSalesGroup1,
      betAmountSalesGroup2: this.betAmountSalesGroup2,
      price: this.price,
      numDraws: this.numDraws,
      betProperties: this.betProperties,
      rowPriceMulti: this.rowPriceMulti,
      drawNum: this.drawNum
    });

    switch (this.wagerModel.get('productId')) {
      case 'LOTTO':
        if (this.wagerModel.get('type') === 'ownrows') {
          bet.erNumberBoardData = {
            boards: this.validBoards.map(boardModel => boardModel.get('numbers').toOwnRowsString())
          };
          bet.egnaRaderParticipation = this.wagerModel.get('rowPriceMulti') === 2 ? 'L1L2' : 'L1';
        } else {
          bet.lottoBoards = this.boards;
        }
        bet.drawNum = svs.numbergames.game.draw[day].drawNumber;
        if (!bet.drawNum && this.isSelfService()) bet.drawNum = svs.numbergames.game.draw[day].nextDrawNumber;
        break;
      case 'EUROJACKPOT':
      case 'VIKINGLOTTO':
        bet.extNumberBoards = this.boards;
        break;
      case 'KENO':
        bet.kenoBoards = this.boards;
    }
    if (!bet.drawNum) bet.drawNum = svs.numbergames.game.draw.drawNumber;
    if (!bet.drawNum && isAlwaysOpen) bet.drawNum = svs.numbergames.game.draw.nextDrawNumber;
    if (!bet.drawNum && this.isSelfService() && this.wagerModel.get('productId') !== 'KENO') bet.drawNum = svs.numbergames.game.draw.nextDrawNumber;
    return bet;
  }
  isSelfService() {
    return Boolean(svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService);
  }
  get betCost() {
    let cost = this.wagerModel.get('numberOfValidBoards') * this.wagerModel.get('rowPrice') * this.numDraws;
    if (svs.numbergames.productMapping.isKeno(this.wagerModel.get('productId'))) cost *= this.wagerModel.get('rowPriceMulti');
    return cost;
  }
  betPriceString() {
    return svs.utils.format.CurrencyAsJupiterString(this.betCost);
  }
  get betAmountSalesGroup1() {
    return this.betPriceString();
  }
  get betAmountSalesGroup2() {
    if (svs.numbergames.productMapping.isKeno(this.wagerModel.get('productId'))) {
      const boardsPrice = this.wagerModel.get('boards').where({
        isValid: true,
        hasKungKeno: true
      }).reduce((accPrice, board) => accPrice + board.get('rowCount') * board.get('rowPrice'), 0);
      return svs.utils.format.CurrencyAsJupiterString(boardsPrice * this.wagerModel.get('rowPriceMulti') * this.numDraws);
    } else if (svs.numbergames.productMapping.isLotto(this.wagerModel.get('productId')) && this.wagerModel.get('rowPriceMulti') === 2) {
      return this.betPriceString();
    }
    return '0,00';
  }
  get betProperties() {
    const betProperties = [];
    if (this.wagerModel.get('prolongedBet')) {
      const wager = this.wagerModel.toObject();
      const isProlonged = svs.numbergames.game_model.utils.prolongation.isProlongedBet(_objectSpread(_objectSpread({}, wager), {}, {
        itsId: this.productItsId
      }));
      if (isProlonged) {
        betProperties.push('PROLONGATION');
      }
    }
    if (this.wagerModel.get('isSyndicate')) betProperties.push('BOLAG');
    if (this.wagerModel.get('type') === 'ownrows') betProperties.push('EGNARADER');
    return betProperties;
  }
  get rowPriceMulti() {
    return 1;
  }
  get price() {
    return this.betPriceString();
  }
  get numDraws() {
    return parseInt(this.wagerModel.get('drawCount'), 10);
  }
  get boards() {
    return this.validBoards.map(boardModel => new svs.numbergames.game_model.utils.API_Board({
      boardModel,
      wagerModel: this.wagerModel
    }));
  }
}
svs.numbergames.game_model.utils.API_Bet = Bet;
 })(window);